import {
    CONFIRMED_GET_NOTIFICATIONS,
    CLEAR_ALL_NOTIFICATIONS,
} from '../actions/notification/NotificationTypes';
import { LOGOUT_ACTION } from '../actions/AuthActions';
const initialState = {
    notifications: [],
};


function NotificationReducer(state = initialState, actions) {
    switch (actions.type) {
        case LOGOUT_ACTION:
            return initialState;
        case CONFIRMED_GET_NOTIFICATIONS:
            if (Array.isArray(actions.payload.rows)) {
                const existingRows = state.notifications?.rows || [];
                const newRows = actions.payload.rows;
                const mergedRows = [...newRows, ...existingRows];
                const uniqueRows = mergedRows.filter(
                    (row, index, self) =>
                        self.findIndex(r => r._id === row._id) === index
                );
                uniqueRows.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                return {
                    ...state,
                    notifications: {
                        ...actions.payload,
                        rows: uniqueRows,
                    },
                };
            }
            return {
                ...state,
                notifications: actions.payload,
            };
        case CLEAR_ALL_NOTIFICATIONS:
            return {
                ...state,
                notifications: actions.payload,
            };
        default:
            return state;
    }
}

export {NotificationReducer};